module.exports = __webpack_public_path__ + "static/bannner-internacionalismo-2-a6596ac632cba4ad59ceff392ecabb89.jpeg";